var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginPresentation',{attrs:{"is-error":_vm.isError},on:{"signin":_vm.handleSignin}})
}
var staticRenderFns = []

export { render, staticRenderFns }